import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const RoleIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M6 2C4.9 2 4 2.9 4 4V6.11914C4 6.48914 4.3878 6.71783 4.7168 6.54883C5.5408 6.12583 6.49916 5.92234 7.53516 6.02734C9.94216 6.27234 11.8752 8.32323 11.9922 10.7402C12.0642 12.2122 11.5253 13.5266 10.6113 14.4766C13.3283 15.2626 15 16.9727 15 19.2188V21C15 21.552 15.448 22 16 22H18C19.1 22 20 21.1 20 20V8.41406C20 8.14906 19.895 7.89403 19.707 7.70703L14.293 2.29297C14.105 2.10497 13.8509 2 13.5859 2H6ZM13 3.5L18.5 9H13V3.5ZM7 8C5.35499 8 4 9.35499 4 11C4 12.645 5.35499 14 7 14C8.64501 14 10 12.645 10 11C10 9.35499 8.64501 8 7 8ZM7 16C5.52355 16 4.16521 16.2326 3.08008 16.6992C2.53751 16.9325 2.05717 17.2248 1.67188 17.6309C1.28658 18.0369 1 18.6007 1 19.2168V20.5C1 21.3171 1.68294 22 2.5 22H11.5C12.3171 22 13 21.3171 13 20.5V19.2168C13 18.6007 12.7134 18.0369 12.3281 17.6309C11.9428 17.2248 11.4625 16.9325 10.9199 16.6992C9.83479 16.2326 8.47645 16 7 16Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

RoleIcon.propTypes = {
  sx: PropTypes.object,
};

export default RoleIcon;
